import styled from 'styled-components/native';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import {ImageBackground, Platform} from 'react-native';
import {
  getBottomSpace,
  getStatusBarHeight,
} from 'react-native-iphone-screen-helper';
import LinearGradient from 'react-native-linear-gradient';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.primary};
`;

export const HelpVideoContainer = styled.TouchableOpacity`
  width: 100%;


  
  height: ${RFPercentage(30)}px;
`;

//@ts-ignore
export const HelpVideoThumb = styled(ImageBackground)`
  width: 100%;


  height: 100%;
`;

export const HelpVideoThumbHeader = styled.View`
  flex:1;
  `;

export const HelpVideoThumbContent = styled.View`
  padding:0 24px;
  
  padding-bottom: ${RFValue(20)}px;
`;

export const VideoInfos = styled.View`
  position: absolute;
  bottom: ${RFValue(32)}px;
  padding: 0 24px;
`;

export const HelpVideoTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  margin-top: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
`;

export const HelpVideoSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;

  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.shape};
`;

//@ts-ignore
export const TopContent = styled(LinearGradient)`
  background-color: ${({theme}) => theme.colors.yellow};

  padding-bottom: ${RFValue(20)}px;

  margin-top: -${RFValue(20)}px;
  z-index: 20;
    border-top-left-radius:${RFValue(20)}px;
  border-top-right-radius:${RFValue(20)}px;
  border-bottom-left-radius:${RFValue(20)}px;
  border-bottom-right-radius: ${RFValue(20)}px;
`;

export const ButtonIcon = styled.TouchableOpacity`
  z-index: 301;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  margin-left: -12px;
  margin-top: -12px;
`;

export const IconHeader = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(22)}px;
`;

export const CheckinContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  padding: 16px;
  border-radius: ${RFValue(20)}px;
`;

export const BaratinhasContainer = styled.View`
padding:0 24px;
  padding-top: ${RFValue(12)}px;
`;

export const BalanceContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(12)}px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Balance = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  line-height: ${RFValue(22)}px;
  margin-left: ${RFValue(2)}px;
`;

export const Title = styled.Text`
  font-size: ${RFValue(20)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
  padding-bottom: ${RFValue(8)}px;
`;

export const Subtitle = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const InfoTitle = styled.Text<{color?: string}>`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme, color = theme.colors.title}) => color};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${Platform.OS === 'ios' ? RFValue(4) : 0}px;
  margin-top: -5px;
`;

export const StreakText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const Content = styled.View`
  flex: 1;
  padding: 16px 24px;
  background-color: ${({theme}) => theme.colors.background};
  margin-bottom: -1000px;
  padding-bottom: 1000px;
  overflow: hidden;

  padding-top: 36px;
  margin-top: -20px;
  z-index: -1;
`;

export const ContentWrapper = styled.View``;

export const InfoItem = styled.View`
  margin-bottom: ${RFValue(12)}px;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
`;
export const InfoItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-top: -5px;
`;
export const InfoDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
`;

export const InfoItemContent = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const Header = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  padding: 0 12px;
  padding-top: ${Platform.OS === 'ios'
    ? getStatusBarHeight() + RFValue(12)
    : RFValue(20)}px;
  z-index: 1;
`;

export const Footer = styled.View`
  margin-top: ${RFValue(12)}px;

  
`;
